module.exports = __webpack_public_path__ + "static/media/dr-carmen-padilla.77d76802.jpg";